export default "__VITE_ASSET__BlyZxfxe__$_?format=webp__"